/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Modal, Row, Spin, Typography } from "antd";
import { FC, SetStateAction } from "react";
import { CloseIcon } from "../Icons";

const { Text } = Typography;

interface ModalProps {
  isModalVisible: boolean;
  setIsModalVisible: React.Dispatch<SetStateAction<boolean>>;
  title: any;
  loading: boolean;
  showLoader?: boolean;
  onCancel?: () => void;
  destroyOnClose?: boolean;
  footerContent?: React.ReactNode;
  width?: number;
  subTitle?: string;
  footerWidth?: number;
  subTitleClassName?: string;
  loaderClassName?: string;
  maskClosable?: boolean;
}

const ModalWrapper: FC<ModalProps> = ({
  isModalVisible,
  setIsModalVisible,
  children,
  title,
  loading,
  showLoader,
  onCancel,
  destroyOnClose,
  footerContent,
  width = 550,
  subTitle,
  footerWidth,
  subTitleClassName = "",
  loaderClassName = "",
  maskClosable = true
}) => {
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      className="ox-modal ox_medium_modal"
      title={
        <div className="flex justify-between items-center">
          <div>
            <span
              className={`font-semibold uppercase mb-2 ${
                subTitle ? "block" : ""
              }`}
            >
              {title}
            </span>
            {subTitle && (
              <Text className={`text-md font-normal ${subTitleClassName}`}>
                {subTitle}
              </Text>
            )}
          </div>
          {!loading && (
            <Button
              onClick={onCancel || handleCancel}
              style={{ margin: 0, padding: 0 }}
              type="text"
            >
              {CloseIcon}
            </Button>
          )}
        </div>
      }
      width={width}
      footer={
        footerContent ? (
          <Row justify="end">
            <Col
              xs={24}
              sm={24}
              md={footerWidth || 10}
              lg={footerWidth || 10}
              xl={footerWidth || 10}
              xxl={footerWidth || 10}
            >
              {footerContent}
            </Col>
          </Row>
        ) : (
          false
        )
      }
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={onCancel || handleCancel}
      centered
      maskClosable={maskClosable && !loading}
      closable={false}
      destroyOnClose={destroyOnClose}
    >
      <div className="relative">
        {showLoader && (
          <div
            className={`absolute inset-0 z-10 flex justify-center pt-36 bg-white opacity-80 ${loaderClassName}`}
          >
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 16, color: "#e7b522" }}
                  spin
                />
              }
            />
          </div>
        )}
        {children}
      </div>
    </Modal>
  );
};

export default ModalWrapper;
